import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const jobsStore = createSlice({
    name: 'jobs',
    initialState: {
        jobsList: [],
        activeIndex: 0, // -1  All
        cartList: [] ,
        cartVisible: false
    },
    reducers: {
        setJobsList(state, action) {
            // state.jobsList = action.payload;
            console.log("Payload received in setJobsList:", action.payload); // Log payload
            state.jobsList = action.payload;
            console.log("Updated state.jobsList:", state.jobsList); // Log updated state
        },
        changeActiveIndex(state, action) {
            console.log("Payload received in setJobsList:", action.payload, state.activeIndex); // Log payload
            state.activeIndex = action.payload;
            console.log("Updated state.jobsList:", state.jobsList, state.activeIndex); // Log updated state
        },
        // Add to Cart
        addCart(state, action) {
            const item = state.cartList.find(item => item.id === action.payload.id);
            if (item) {
                item.count++;
            }
            else {
                state.cartList.push(action.payload);
            }
        },
        // increaseCount(state, action) {
        //     const item = state.cartList.find(item => item.id === action.payload.id);
        //     item.count++;
        // },
        increaseCount(state, action) {
            const { id, job } = action.payload;
            const item = state.cartList.find(item => item.id === id);

            if (item) {
                item.count++;
            } else {
                state.cartList.push({
                    ...job,
                    count: 1
                });
            }
        },
        // decreaseCount(state, action) {
        //     const item = state.cartList.find(item => item.id === action.payload.id);
        //     if (item.count === 0) {
        //         return;
        //     }
        //     item.count--;
        // },
        decreaseCount(state, action) {
            const item = state.cartList.find(item => item.id === action.payload.id);
            if (!item) return;

            item.count--;

            if (item.count <= 0) {
                state.cartList = state.cartList.filter(i => i.id !== item.id);
            }
        },
        clearCart(state) {
            state.cartList = [];
        },
        showCart(state) {
            state.cartVisible = true;
        },
        hideCart(state) {
            state.cartVisible = false;
        },
        moveJob: (state, action) => {
            const { index, direction } = action.payload; // direction: 'up' | 'down'
            const newIndex = direction === 'up' ? index - 1 : index + 1;
            if (newIndex >= 0 && newIndex < state.cartList.length) {
                const temp = state.cartList[index];
                state.cartList[index] = state.cartList[newIndex];
                state.cartList[newIndex] = temp;
            }
        }

    }
});

// Asynchronous data acquisition
// const { setJobsList, changeActiveIndex, addCart, increaseCount, decreaseCount, clearCart } = jobsStore.actions;
const { 
  setJobsList, 
  changeActiveIndex, 
  increaseCount, 
  decreaseCount, 
  clearCart,
  showCart,      
  hideCart,
  moveJob      
} = jobsStore.actions;

const fetchJobsList = () => {
    return async (dispatch) => {
        //const res = await axios.get('http://localhost:3004/Jobs');
        //https://dc28.job-bid.ca/server/jobs.php
        // const res = await axios.get('https://dc28.job-bid.ca/server/jobs.php');

        // console.log("res.data:", res.data);

        // dispatch(setJobsList(res.data));
        try {
            const res = await axios.get("https://dc28.job-bid.ca/server/jobs.php");
            console.log("res.data:", res.data);
            dispatch(setJobsList(res.data));
        } catch (error) {
            console.error("Error fetching jobs:", error);
        }
    }
};



// export { fetchJobsList, changeActiveIndex, addCart, increaseCount, decreaseCount, clearCart };
export { 
  fetchJobsList, 
  changeActiveIndex, 
  increaseCount, 
  decreaseCount, 
  clearCart,
  showCart,      
  hideCart,
  moveJob    
};

const jobsReducer = jobsStore.reducer;
export default jobsReducer;